import React, { useEffect, useState } from 'react'
import { fetchCurrencies } from '../../api/api_currency'

function AllCurrencies() {

    const [currencies, setCurrencies] = useState([])

    useEffect(() => {
        async function fetchData() {
            const response = await fetchCurrencies();
            if (response.data.currencies) {
                const currenciesArray = Object.keys(response.data.currencies).map((key) => [String(key), response.data.currencies[key]]);
                setCurrencies(currenciesArray)
            }
            console.log(response.data, "Response useEffect")
        }
        fetchData()

    }, [])

    return (
        <div className="container my-3">
            <h2>Currencies</h2>
            {currencies?.map((currency, index) => {
                return <p key={index}>{currency[0]} - {currency[1]}</p>
            })}
        </div>
    )
}
export default AllCurrencies